// removed by extract-text-webpack-plugin
module.exports = {"root":"noteSection__root--3TOLS","title":"noteSection__title--zqff0 thinBigText","overlay":"noteSection__overlay--1yogb","titleString":"noteSection__titleString--1w9hC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/NoteSection/noteSection.css
// module id = X1wF
// module chunks = 0